module.exports = __webpack_public_path__ + "static/pawprints_mobile-1798611efaf83c60cdc22713406952be.jpeg";